export default __webpack_public_path__ + "static/media/0000..0001.00f7f50e.png";